import useSettings from "app/hooks/useSettings";

const QuizWizLogo = ({ className }) => {
  const { settings } = useSettings();
  const theme = settings.themes[settings.activeTheme];

  return (
    <img
      src="/assets/images/quizwizlogo.png"
      alt="QuizWiz Logo"
      width="24"
      height="24"
    />
  );
};

export default QuizWizLogo;
